import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import {
  apply_closed_text,
  is_deposit_card_open,
  is_invest_card_open,
  is_prepaid_card_open
} from '@/app/availlability_vars';
import ApplePayIcon from '@/assets/images/icons/ApplePayIcon';
import GarminPayIcon from '@/assets/images/icons/GarminPayIcon';
import GooglePayIcon from '@/assets/images/icons/GooglePayIcon';
import SamsungPayIcon from '@/assets/images/icons/SamsungPayIcon';
import TickIcon from '@/assets/images/icons/TickIcon';
import Light from '@/assets/images/right-light.svg';
import { BigTitle, Button, SubBody, SubTitle } from '@/components';

const payment = [
  {
    icon: <ApplePayIcon />,
    link: 'https://bankffin.kz/ru/page/kak-podkliucit-kartu-k-apple-pay-na-smartfone'
  },
  {
    icon: <GooglePayIcon />,
    link: 'https://bankffin.kz/ru/page/kak-podkliucit-kartu-k-google-pay-na-smartfone'
  },
  {
    icon: <SamsungPayIcon />,
    link: 'https://bankffin.kz/ru/page/kak-podkliucit-kartu-k-samsung-pay-na-smartfone'
  },
  {
    icon: <GarminPayIcon />,
    link: ''
  }
];

function CardBanner({ benefits, buttonText, cardImage, title, navigateUrl, type }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navigateTo = navigateUrl;

  const handleReturnIsButtonDisabled = () => {
    switch (type) {
      case 'deposit':
        return is_deposit_card_open;
      case 'invest':
        return is_invest_card_open;
      case 'prepaid':
        return is_prepaid_card_open;
      default:
        break;
    }
  };
  return (
    <div tw='flex lg:flex-row flex-col-reverse sm:items-start items-center sm:gap-20 gap-10'>
      <div tw='flex flex-col justify-between gap-7'>
        <div tw='max-w-max sm:px-0 px-3'>
          <BigTitle text={title} twStyle={tw`sm:text-[50px] text-[32px] text-[#70FF6E]`} />
          <div tw='sm:py-5 flex flex-col lg:row-gap-5 row-gap-5 justify-between lg:mt-0 mt-5 '>
            {benefits?.map(item => (
              <div tw='flex gap-2 items-center' key={item}>
                <TickIcon />
                <SubTitle text={item} />
              </div>
            ))}
          </div>
        </div>

        <div tw='flex justify-between sm:gap-2 gap-1 sm:w-1/3'>
          {payment.map((item, idx) => (
            <a href={item.link} tw='' key={idx} target='_blank' rel='noreferrer'>
              <div tw='bg-[#ffff] max-w-[100px] py-3 px-2 h-[36px] flex justify-center items-center rounded-[8px] w-full'>
                {item.icon}
              </div>
            </a>
          ))}
        </div>
        <div tw='sm:text-left text-center sm:px-0 px-3'>
          <Button
            variant='ghost'
            twStyle={tw`sm:max-w-[200px] text-center`}
            disabled={!handleReturnIsButtonDisabled()}
            onClick={() => {
              navigate(`${navigateUrl}`);
            }}
          >
            {buttonText}
          </Button>
        </div>
        {!handleReturnIsButtonDisabled() && (
          <SubBody
            text={<span>{apply_closed_text}</span>}
            twStyle={tw`text-secondary -mt-5 text-justify sm:px-0 px-3`}
          />
        )}
        {handleReturnIsButtonDisabled() && type !== 'prepaid' && (
          <SubBody
            text={t('deposit.deposit_banner.caption')}
            twStyle={tw`text-secondary -mt-5 text-justify sm:px-0 px-3`}
          />
        )}
      </div>

      <div tw='flex flex-col gap-5 mt-5 relative items-center max-w-[350px]'>
        <img src={cardImage} alt='картинка' tw='' />
        <img src={Light} alt='' tw='mr-10' />
      </div>
    </div>
  );
}

export default CardBanner;
